import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import {
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../../helpers/global_helper";
import { formatPrice } from "../../NumberFormat";

const JackpotMoPopup = (props) => {
  const { nickname, amount, game } = props;



  return (

    <div className="poupup_detail_table" style={{marginBottom:'15px'}}>
      <table className="table_data" border="0">
        <thead>
          <tr>
            <th>{props.t("nickname")}</th>
            <th>{props.t("jackpot")}</th>
            <th>{props.t("jackpot_amount")}</th>
            <th>{props.t("game")}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            className="first_bg"
          >
            <td>{nickname}</td>
            <td>{"Regular Jackpot"}</td>
            <td>{formatPrice(amount)}</td>
            <td>{game}</td>
          </tr>

        </tbody>
      </table>
</div>



  


  );
};

export default withTranslation()(JackpotMoPopup);
